import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthdataService {

  currentFN: any  = new BehaviorSubject<any>(null)
  currentLN: any  = new BehaviorSubject<any>(null)
  currentemail: any  = new BehaviorSubject<any>(null)
  currenttoken  = new BehaviorSubject<string>(" ")

x:any=localStorage.getItem("Token"); 

  constructor( private _HttpClient:HttpClient) { 
    this.currenttoken.next(this.x)

    }
  



  getSignUp(UserData:object):Observable<any>    {    return this._HttpClient.post("https://routeegypt.herokuapp.com/signup",UserData)   }




  getSignIn(loginData:object):Observable<any> {    return this._HttpClient.post("https://routeegypt.herokuapp.com/signin",loginData)  }



  UserInfo( FN: any , LN:any, Email:any , Token:any ){
 
    this.currentFN.next(FN)
    this.currentLN.next(LN)
    this.currentemail.next(Email)
    this.currenttoken.next(Token)  
    
    

  }






}
